import { useQuery } from '@tanstack/react-query';
import { GET_WAREHOUSE_SCHEDULED_EVENTS } from "../../constants";
import { getWarehouseDynamicSchedulerEvents, getWarehouseSchedulerEvents } from "@/helpers/apis";

const useWarehouseScheduler = ({
  instance_id,
  warehouse_name,
  isDynamic = false,
  start_time,
  end_time,
  enabled = true,
}: {
  instance_id: string;
  warehouse_name: string;
  isDynamic?: boolean;
  start_time?: string;
  end_time?: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [GET_WAREHOUSE_SCHEDULED_EVENTS, instance_id, warehouse_name, start_time],
    queryFn: () => {
      if (isDynamic)
        return getWarehouseDynamicSchedulerEvents({
          instance_id,
          warehouse_name,
          start_time,
          end_time,
        });
      return getWarehouseSchedulerEvents({
        instance_id,
        warehouse_name,
        start_time,
        end_time,
      });
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled
  });
};

export default useWarehouseScheduler;
